module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABFElEQVR4AdVQA2ggAADc+3+244ww27ZtpcXF2XaebVthDrNt20o323F/dflI8EXgYQYiX1uUjXTitK8TSzqSmJfifJd3et0oBVyaXNK9IQ9nm2tYc7b4uMFEMgVCEgTxw9P0ykQxOQCbezvYiQ36mAElyTfUBpChIZsdNL4GVyZMwU7oXJrGWyB4APz4TgA/a0JMFzNDKET90uRdPjK4pYcZIXbK6cEbpPV5AzcTQswXM0IiVO1zDYj/fUOJFymacllBf/MBfZAj2ufHP/bBaAIFohL58dvT5EosneCLxd1teAU3g5g54lXeGZjFyN3VcqnJwMb2EbTNCt4UPzK4FP71sUZufzu6+1fBJRL/tvixwf+Oc7k4WlxIzlREAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/ZA.png
// module id = 1306
// module chunks = 0